var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "c-newsletterSignup" }, [
    _vm.isForm
      ? _c("div", { staticClass: "c-newsletterSignup__form" }, [
          _c("div", { staticClass: "c-newsletterSignup__text" }, [
            _c("h2", [_vm._v(_vm._s(_vm.heading))]),
            _vm._v("\n\t\t\t" + _vm._s(_vm.text) + "\n\t\t")
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "c-newsletterSignup__email" }, [
            _c("div", { staticClass: "o-input" }, [
              _c("input", {
                directives: [
                  {
                    name: "model",
                    rawName: "v-model",
                    value: _vm.email,
                    expression: "email"
                  }
                ],
                staticClass: "o-input__input",
                class: {
                  "o-input__input--filled": _vm.email
                },
                attrs: { type: "email", name: "email" },
                domProps: { value: _vm.email },
                on: {
                  input: function($event) {
                    if ($event.target.composing) {
                      return
                    }
                    _vm.email = $event.target.value
                  }
                }
              }),
              _vm._v(" "),
              _c("div", { staticClass: "o-input__label" }, [
                _vm._v(
                  "\n\t\t\t\t\t" +
                    _vm._s(_vm.translations["Email"]) +
                    "\n\t\t\t\t"
                )
              ])
            ]),
            _vm._v(" "),
            _c(
              "div",
              {
                staticClass: "c-newsletterSignup__email__apply",
                class: { loading: _vm.isLoading },
                on: {
                  click: function($event) {
                    return _vm.SignUp()
                  }
                }
              },
              [
                _vm._v(
                  "\n\t\t\t\t" +
                    _vm._s(_vm.translations["Sign up"]) +
                    "\n\t\t\t\t"
                ),
                _c("inline-loader")
              ],
              1
            )
          ])
        ])
      : _vm._e(),
    _vm._v(" "),
    _vm.isSuccess
      ? _c("div", { staticClass: "c-newsletterSignup__success" }, [
          _c("div", { staticClass: "c-newsletterSignup__text" }, [
            _c("h2", [_vm._v(_vm._s(_vm.successheading))]),
            _vm._v("\n\t\t\t" + _vm._s(_vm.successtext) + "\n\t\t")
          ]),
          _vm._v(" "),
          _c(
            "div",
            {
              staticClass: "o-btn c-newsletterSignup__button",
              on: {
                click: function($event) {
                  return _vm.toForm()
                }
              }
            },
            [_vm._v("\n\t\t\tOkay\n\t\t")]
          )
        ])
      : _vm._e(),
    _vm._v(" "),
    _vm.isFail
      ? _c("div", { staticClass: "c-newsletterSignup__fail" }, [
          _c("div", { staticClass: "c-newsletterSignup__text" }, [
            _c("h2", [_vm._v(_vm._s(_vm.message))])
          ]),
          _vm._v(" "),
          _c(
            "div",
            {
              staticClass: "o-btn c-newsletterSignup__button",
              on: {
                click: function($event) {
                  return _vm.toForm()
                }
              }
            },
            [_vm._v("\n\t\t\tPrøv igen\n\t\t")]
          )
        ])
      : _vm._e()
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }